import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useVariables} from '../../../assets/objects/Variables.js';
import {getPreviewText} from '../utils/richTextStepPreviewSnippet';

/** getTopValue for fullDescription: same variable set as TextEditor on subscription flow (useVariables + ticket type). */
export function useFullDescriptionStepTopPreview() {
    const {t: translateVariable} = useTranslation('variables');
    const {defaultVariables, disabledVariables} = useVariables('ticket');

    return useCallback(
        (value: string | undefined) =>
            getPreviewText(
                value,
                {...defaultVariables, ...disabledVariables},
                translateVariable
            ),
        [disabledVariables]
    );
}
